import {Radio} from 'antd';
import {BASIC_ELEMENT_SCHEMA} from "../layout/Group";
import {FieldControlProps} from "../metadata/fieldControlProps";

import React, { useContext} from 'react';
import { GlobalStateContext } from '../../context/GlobalStateProvider';

export const YesNoRadio = ({ value, onChange, ...props }: FieldControlProps<boolean>) => {
  const {isDesktop } = useContext(GlobalStateContext);

  const coercedValue: string = (undefined  !== value ? value.toString() :  null);

  const handleToggle = e => onChange(e.target.value === 'Yes');

  return <Radio.Group
    value={coercedValue}
    onChange={handleToggle}
    style={{width: !isDesktop ?'116px':'',
      marginTop:!isDesktop ?'24px':'',
      textAlign: 'justify',
      display: !isDesktop ?'block':'inline-block'}}
    {...props}
  >

    <Radio value="Yes" >Yes</Radio>
    <Radio value="No">No</Radio>
  </Radio.Group>
  ;
};

YesNoRadio.schema = BASIC_ELEMENT_SCHEMA;